import React from "react";
import Layout from "./Layout";
import { MediaModel } from "../models";
import Header from "./Header";
import { MediaItem, MediaType } from "@mindmemobile/mm-shared-library";
import MediaBoxes from "./MediaBoxes";
import { toJS } from "mobx";
import { MediaTypes } from "../enums";
import { observer } from "mobx-react";

type IProps = {
  hideLabel?: boolean;
  allowedMediaTypes?: (keyof typeof MediaType)[];
  medias?: MediaModel[];
  onUpload: (medias: MediaModel[]) => void;
  onDelete: (media: MediaModel) => void;
  multiple: boolean;
  onSelectLibraryMedia: (media: MediaItem) => void;
  onFavourite?: (media: MediaModel) => void;
  showUploadButtons?: boolean;
  hideOverlays?: boolean;
  allowOnlyOne?: boolean;
  toggleLibrary: (show: boolean, fromUpload?: boolean) => void;
  showLibrary: boolean;
  updateMedia: (medias: MediaModel[]) => void;
  showUpload?: boolean;
};

const FullLibraryView: React.FC<IProps> = (props) => {
  return (
    <Layout
      sideBarComponent={null}
      showSaveAndExit={true}
      headerCaption={""}
      backClick={() => {}}
      showHeader={false}
      showFooter={false}
      showCancelButton={false}
      padding={"0px"}
      headerComponent={
        <Header
          headerCaption={""}
          showSaveButton={false}
          saveAndExitButtonCaption={""}
          showSaveAndExitButton={false}
          cancelClick={() => props.toggleLibrary(false, false)}
          cancelButtonCaption={"CANCEL"}
          saveAndExitClick={() => {}}
        />
      }
      cancelClick={() => {}}
      nextClick={() => {}}
      showNextButton={false}
    >
      <MediaBoxes
        key={"medias"}
        multiple={props.multiple}
        hideLabel={props.hideLabel}
        hideOverlays={props.hideOverlays}
        allowOnlyOne={props.allowOnlyOne}
        medias={toJS(props.medias || [])}
        onUpload={(medias: MediaModel[]) => props.updateMedia(medias)}
        onDelete={(media: MediaModel) => props.onDelete(media)}
        onSelectLibraryMedia={(media) => props.onSelectLibraryMedia(media)}
        onFavourite={(media: MediaModel) =>
          props.onFavourite && props.onFavourite(media)
        }
        allowedMediaTypes={props.allowedMediaTypes}
        toggleLibrary={(show: boolean, fromUpload?: boolean) =>
          props.toggleLibrary(show, fromUpload)
        }
        showLibrary={props.showLibrary}
        showUpload={props.showUpload}
      />
    </Layout>
  );
};

export default observer(FullLibraryView);
